export const oldTheme = {
  colors: {
    primary: "#2F735F",
    yellow: "#fde410",
    white: "#fff",
    gray: "#b2b2b2",
    black100: "#3D3D3D",
    black200: "#313131",
    black300: "#3A3A3A",
  },
  text: {
    primary: "#1c1c1c",
    secondary: "#ffffff80",
    white: "#fff",
    green: "#00b574",
  },
  backgroundColors: {
    primary: "#222",
    second: "#189970",
    third: "#535353",
  },
  validate: {
    error: "#ff4d4f",
  },
} as const;

export const theme = {
  colors: {
    ...oldTheme.colors,
    neutrals: {
      50: "#F5F5F9",
      100: "#E5E5E6",
      200: "#CACACE",
      300: "#AFAFB5",
      400: "#95959D",
      500: "#7B7B84",
      600: "#636369",
      700: "#4A4A4F",
      800: "#313135",
      900: "#1C1C1E",
    },
    primary: {
      50: "#BACCEA",
      300: "#6F7C93",
      500: "#424955",
      700: "#30353F",
      900: "#1A1D22",
    },
    secondary: {
      50: "#DCB3B0",
      300: "#D9948F",
      500: "#DC776F",
      700: "#E35F55",
      900: "#DD3023",
    },
    gradient: {
      1: "linear-gradient(to right, #FA5A00 , #FF0F00)",
      2: "linear-gradient(180deg, rgba(235, 0, 0, 0.5625) 0%, rgba(221, 48, 35, 0) 100%)",
      3: "linear-gradient(180deg, #FC2E1E 0%, #840B0B 100%);",
    },
    background: {
      white: "#FFFFFF",
      100: "#000000",
    },
  },
  fontSize: {
    16: "16px",
    20: "20px",
    24: "24px",
    32: "32px",
    36: "36px",
    40: "40px",
    48: "48px",
    64: "64px",
    96: "96px",
  },
  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },

  text: {
    ...oldTheme.text,
  },
  backgroundColors: {
    ...oldTheme.backgroundColors,
  },
  validate: {
    ...oldTheme.validate,
  },
} as const;
